import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { Table } from "../../../s25-table/Table";
import { Bind } from "../../../../decorators/bind.decorator";
import { S25TableComponent } from "../../../s25-table/s25.table.component";
import { UserService } from "../../../../services/user.service";
import { UserprefService } from "../../../../services/userpref.service";
import { S25Datefilter } from "../../../s25-dateformat/s25.datefilter.service";
import { S25ItemContactComponent } from "../../../s25-item/item-object/s25.item.contact.component";
import { S25Util } from "../../../../util/s25-util";

@TypeManagerDecorator("s25-ng-signed-in-users")
@Component({
    selector: "s25-ng-signed-in-users",
    template: `
        @if (init) {
            <div class="signed-in-users-wrapper">
                <h2 class="c-margin-bottom--single">User Sessions</h2>
                <s25-ng-table
                    [dataSource]="tableConfig"
                    [hasFilter]="true"
                    [hasRefresh]="true"
                    [helpTopic]="'signed_in_users_list'"
                    [columnSortable]="true"
                    [pivotThreshold]="900"
                >
                    <ng-template #tableHeaderRight let-defaultRight="defaultRight">
                        <s25-ng-checkbox [(modelValue)]="hideViewerSeat" (modelValueChange)="tableComp.refresh()">
                            Hide Viewer Seat
                        </s25-ng-checkbox>
                        <ng-container *ngTemplateOutlet="defaultRight" />
                    </ng-template>
                </s25-ng-table>
            </div>
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25SignedInUsersComponent implements OnInit {
    init: boolean;
    tableConfig: Table.DataSource;
    hideViewerSeat: boolean = false;

    columns: Table.Column[] = [
        { id: "name", header: "Name" },
        { id: "email", header: "Email Address" },
        { id: "date", header: "Date Signed In" },
        { id: "computer", header: "Computer Used" },
        { id: "count", header: "Count" },
    ];

    @ViewChild(S25TableComponent) tableComp: S25TableComponent;

    constructor(private cd: ChangeDetectorRef) {}

    async ngOnInit() {
        this.tableConfig = {
            type: "unpaginated",
            dataSource: this.getRows,
            columns: this.columns,
        };

        this.init = true;
        this.cd.detectChanges();
    }

    @Bind
    async getRows(): Promise<Table.DataSourceResponse> {
        const contactToFilter = this.hideViewerSeat ? "viewer25" : null;

        const [sessions, dateTimePref] = await Promise.all([
            UserService.getUserSessions(contactToFilter),
            UserprefService.getS25DateTimeformat(),
        ]);

        return {
            rows: sessions?.map((session) => {
                return {
                    id: session.username,
                    name: session.username,
                    cells: {
                        name: {
                            component: S25ItemContactComponent,
                            inputs: {
                                modelBean: {
                                    itemName: session.contactName,
                                    itemId: +session.contId,
                                },
                            },
                            textValue: session.contactName,
                        },
                        email: { text: session.email },
                        date: {
                            text: S25Datefilter.transform(session.logonDate, dateTimePref),
                            sortValue: S25Util.date.toS25ISODateTimeStr(session.logonDate),
                        },
                        computer: { text: session.computer },
                        count: { text: session.count },
                    },
                };
            }),
        };
    }
}
